/*
 *  Server side API
 *
 *  @version 1.0
 *
 **/
module.exports = ( Vue ) => { 

    Vue.prototype.ajax = {

    	//Loader
        ldr : $('#ldr'),
    	l2  : false,

     	//Ajax Sign-out
     	signOut() {
     		//this.loader('show');

     		$.ajax({
     			type 	: 'POST',
     			url 	: '/logout',

     			//Logout success, reload page
     			success() {
     				location.reload();
     			},

     			//Backend error
     			error() {

     			}
     		});

     	},

     	//Ajax Calls
        call( url, data, callback ) {

            if( typeof data.noLoad == 'undefined' ) {

            	this.loader('show');
            
            }
            
            var me = this;

            $.ajax({
                type : "POST",
                url  : "/system/" + url,
                data : data,

                success : function(response){
                    if(typeof callback == 'function'){
                        
                        if( typeof response.data == 'string' ){
                            response.data = JSON.parse( response.data );
                        }

                        callback( response );
                    }
                },

                error : function(response){
                    $.notify('Възникна неочакван сървърен проблем.');
                    
                    var data = { 
                        url     : '/system/' + url, 
                        data    : JSON.stringify(data), 
                        file    : '', 
                        line    : '', 
                        message : '', 
                        status  : response.status
                    };

                    if( typeof response.responseJSON == 'object' ){
                    
                        data.file    = response.responseJSON.file;
                        data.line    = response.responseJSON.line;
                        data.message = response.responseJSON.message;
                    
                    } else {

                        data.message = responseText.substr(0,200);

                    }

                    //Log error for inspection
                    // $.ajax({ url : '/system/logAjaxError', data : data, type : "POST" });
                }

            }).done(function(){
                
                me.loader('hide');
            });
        },

        loader(command, to) {
            // if(!this.ldr.length){
            //     this.ldr = $("<div id='ldr'><h2>Моля изчакайте...</h2><img src='/images/loader.svg'/></div>");
            //     this.ldr.appendTo($('body')); 
            // }

            switch( command ) {
                case 'show'     : bus.$emit('loader', true); break;
                case 'hide'     : bus.$emit('loader', false); break;
                case 'remove'   : this.ldr.remove(); break;
            }
        },

        resolveError(){
            // var h1  = $("<h3>Възникна неочакван проблем</h3>");
            // var btn = $("<button class='btn btn-primary ' onclick='location.reload()'>Презареди</button>");

            // this.ldr.html('');
            // h1.appendTo(this.ldr);
            // btn.appendTo(this.ldr);

            // this.loader('show');
        }
    }

}